import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchCommands } from '../enums';
import { IInlineSearchApplication } from '../InlineSearchApplication.interface';

export class InlineSearchReadyEvent implements IEvent {
	public static readonly EventType = InlineSearchCommands.INLINE_SEARCH_READY_EVENT;

	public readonly timestamp = new Date();
	public readonly eventType = InlineSearchReadyEvent.EventType;
	public inlineSearchApplication: IInlineSearchApplication;

	constructor(inlineSearchApplication: IInlineSearchApplication) {
		this.inlineSearchApplication = inlineSearchApplication;
	}

	public static is(event: IEvent): event is InlineSearchReadyEvent {
		return event.eventType === InlineSearchReadyEvent.EventType as string;
	}
}